module.exports = __webpack_public_path__ + "img/Eu.6a2a3409.jpg";